export default `
-- CreateTable
CREATE TABLE "Star" (
    "id" TEXT NOT NULL PRIMARY KEY,
    "workspace_id" TEXT NOT NULL,
    "created_by" TEXT NOT NULL,
    "parent_type" TEXT NOT NULL,
    "parent_id" TEXT NOT NULL,
    CONSTRAINT "Star_workspace_id_fkey" FOREIGN KEY ("workspace_id") REFERENCES "Workspace" ("id") ON DELETE RESTRICT ON UPDATE CASCADE
);

-- CreateIndex
CREATE INDEX "Star_parent_type_idx" ON "Star"("parent_type");

-- CreateIndex
CREATE INDEX "Star_parent_id_idx" ON "Star"("parent_id");

-- CreateIndex
CREATE INDEX "Star_workspace_id_idx" ON "Star"("workspace_id");

-- CreateIndex
CREATE INDEX "Star_created_by_idx" ON "Star"("created_by");
`;
